import { Props as IDotLottiePlayerProps } from '@dotlottie/react-player';
import React from 'react';
import { OrbitSuspense } from '../base-components/orbit-suspense/orbit-suspense';

const Player = React.lazy(
    () => import('@dotlottie/react-player').then(({ DotLottiePlayer }) => ({ default: DotLottiePlayer }))
);

export const DotLottiePlayer = React.forwardRef((props: IDotLottiePlayerProps, ref: any) => {
    return <OrbitSuspense>
        <Player
            ref={ref}
            {...props}
        />
    </OrbitSuspense>;
});
